export const CREATE_PRIZE_REQUEST = 'prize/CREATE_PRIZE_REQUEST';
export const CREATE_PRIZE_SUCCESS = 'prize/CREATE_PRIZE_SUCCESS';
export const CREATE_PRIZE_FAILURE = 'prize/CREATE_PRIZE_FAILURE';

export const READ_PRIZE_REQUEST = 'prize/READ_PRIZE_REQUEST';
export const READ_PRIZE_SUCCESS = 'prize/READ_PRIZE_SUCCESS';
export const READ_PRIZE_FAILURE = 'prize/READ_PRIZE_FAILURE';

export const UPDATE_PRIZE_REQUEST = 'prize/UPDATE_PRIZE_REQUEST';
export const UPDATE_PRIZE_SUCCESS = 'prize/UPDATE_PRIZE_SUCCESS';
export const UPDATE_PRIZE_FAILURE = 'prize/UPDATE_PRIZE_FAILURE';

export const DELETE_PRIZE_REQUEST = 'prize/DELETE_PRIZE_REQUEST';
export const DELETE_PRIZE_SUCCESS = 'prize/DELETE_PRIZE_SUCCESS';
export const DELETE_PRIZE_FAILURE = 'prize/DELETE_PRIZE_FAILURE';

export const READ_PRIZES_REQUEST = 'prize/READ_PRIZES_REQUEST';
export const READ_PRIZES_SUCCESS = 'prize/READ_PRIZES_SUCCESS';
export const READ_PRIZES_FAILURE = 'prize/READ_PRIZES_FAILURE';


// WEBPACK FOOTER //
// ./src/modules/prize/prize.actionTypes.js